import {Injectable} from '@angular/core';
import {MsalService} from '@azure/msal-angular';
import {environment} from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class StorageCleanupService {
  constructor(
    private authService: MsalService
  ) { }
  clearAppStorage() {
    localStorage.clear();
    this.authService.logoutRedirect({ postLogoutRedirectUri: environment.postLogoutUrl });
  }
}